import { BrainIcon } from "lucide-react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

// What Sadie remembers about the selected worker from an earlier session,
// as the prompt will see it. Read only: it is an input to the run, and the
// prompt editor already shows exactly where it lands.
export const SadieSimulatorWorkerDigest = ({
  digest,
  intentLevel,
}: {
  digest: string;
  intentLevel: string | null;
}) => (
  <Column className="gap-1.5 rounded-lg border border-slate-200 bg-white p-3">
    <Row className="items-center justify-between gap-2">
      <Row className="items-center gap-2">
        <BrainIcon className="h-4 w-4 shrink-0 text-slate-400" />
        <Text className="text-sm font-medium text-slate-700">
          What Sadie remembers
        </Text>
      </Row>
      {intentLevel ? (
        <Text className="text-[11px] font-medium lowercase text-slate-500">
          {intentLevel.replace("_", " ")}
        </Text>
      ) : null}
    </Row>
    <Text className="text-xs font-normal leading-relaxed text-slate-600">
      {digest}
    </Text>
  </Column>
);
